// Common
import transfer_logo from '/app/assets/images/new_design/airport_shuttle.svg'

export default class CampListTransferMobile extends React.Component {
    render() {
        return (
          <div className='card card_big camp-list-transfer'>
              <img className='img' src={transfer_logo}/>
              <div className='text'>
                  <h3 className='camp-list-transfer__title'>Трансфер в подарок</h3>
                  <p className='text-sub'>Встретим вас от ж/д вокзала или аэропорта и доставим до объекта размещения.</p>
                  <a href='/pages/promo' className='typography-normal weight-500 under'>
                      Подробнее об акции
                  </a>
              </div>
          </div>
        );
    }
}
